import TienesElControl from "../assets/img/discography/tienes_el_control.jpg";
import NavidadVol4 from "../assets/img/discography/navidad_vol4_Jesus_es_el_motivo.jpg";
import Adora247 from "../assets/img/discography/adora_24_7_v1.jpg";
import Jesus from "../assets/img/discography/jesus.jpg";
import JesusTrackByCommentary from "../assets/img/discography/jesus_commentary.jpg";
import NavidadVol3 from "../assets/img/discography/navidad_vol3.jpg";
import ElCieloEnLaTierra from "../assets/img/discography/el_cielo_en_la_tierra_pianos_para_orar.jpg";
import FragmentosDelCielo from "../assets/img/discography/fragmentos_del_cielo.jpg";
import ViveEnMi from "../assets/img/discography/vive_en_mi.jpg";
import Himnos from "../assets/img/discography/himnos.jpg";
import Fiel from "../assets/img/discography/fiel.jpg";
import BichosFreak from "../assets/img/discography/bichos_freak_con_alex_campos.jpg";
import El from "../assets/img/discography/el.jpg";
import JesusFreak from "../assets/img/discography/jesus_freak.jpg";
import CielosAbiertos from "../assets/img/discography/cielos_abiertos_en_vivo.jpg";
import VoyBuscando from "../assets/img/discography/voy_buscando.jpg";

import BackgroundJuanMunoz from "../assets/img/banda/background_juan_munoz.jpg";
import BackgroundHistory1 from "../assets/img/banda/background-history-1.jpg";

const DiscographyImages = {
  TienesElControl,
  NavidadVol4,
  Adora247,
  Jesus,
  JesusTrackByCommentary,
  NavidadVol3,
  ElCieloEnLaTierra,
  FragmentosDelCielo,
  ViveEnMi,
  Himnos,
  Fiel,
  BichosFreak,
  El,
  JesusFreak,
  CielosAbiertos,
  VoyBuscando,
};

const BandaImages = {
  BackgroundHistory1,
  BackgroundJuanMunoz,
};

export { DiscographyImages, BandaImages };
